import { router } from './router/index.js';
import { tooltip } from './components/tooltip/index.js';

tooltip.initialize();

router
  .addRoute(/^$/, 'top-rated-movies')
  .addRoute(/^all-movies/, 'all-movies')
  .addRoute(/^movie-details\/([\w()-]+)$/, 'movie-details')
  .addRoute(/^create-movie$/, 'create-movie')
  .addRoute(/^my-collection$/, 'my-collection')
  .setNotFoundPagePath('error404')
  .listen();
